import {call, select, all, put} from "redux-saga/effects"

import api from "../../services/ApiService"
import {HomeCreators as Creators} from "./redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {AppCreators} from "../App/redux"
import {checkEnv, i18n} from "../../utils"

export default function* home(_dispatch, _action) {
  const state = yield select()

  const lang = state.router.params.lang
  let langurl

  lang === "de" ? (langurl = "/en/") : (langurl = "/de/")

  // request content
  yield put(Creators.request())

  try {
    const [
      categoriesResponse,
      topicResponse,
      contentResponse,
      latestArticlesResponse
    ] = yield all([
      call(api.getKnowledgeCategories, lang),
      checkEnv("DISABLE_LEARNING")
        ? call(() => [])
        : call(api.getLearningThemes, lang),
      call(api.getPageContentBySlug, "startseite", lang),
      call(api.getLatestKnowledgeArticles, lang)
    ])

    yield put(LangCreators.success(langurl))

    yield put(
      Creators.success(
        categoriesResponse,
        topicResponse,
        contentResponse,
        latestArticlesResponse
      )
    )

    // tracking
    yield put(
      AppCreators.trackingAdd({
        event: "mtm.virtualPageView",
        section: "pages",
        page_type: "page",
        page_name: contentResponse.post_title,
        document_title: i18n.t("Startseite")
      })
    )
  } catch (e) {
    yield put(Creators.error(e.message))
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home/sagas.js